export const LOGIN_URL = ENV_DEV ?
    "http://api.quanmaikeji.cn/manniu/user/jump_auth_url" :
    "http://api.quanmaikeji.com/manniu/user/jump_auth_url";